import Base from "./base";
import apiDispatcher from "@/utils/api-dispatcher";
import { INDEX_WITH_EXTRA } from "@/utils/api-url";

export default class Tag extends Base {
  constructor(params = {}) {
    super(params);
    this.id = params["_id"];
    this.name = params["tagName"];
  }

  static resourceName() {
    return "tag";
  }

  static index() {
    return apiDispatcher(INDEX_WITH_EXTRA({}, "tag"));
  }
}
